<template>
  <div ref="panel" class="loginpage">
   <!--  <div class="contact-box">
      <div class="contact" style="display: flex; justify-content: flex-end; align-items: flex-end">

        <div style="">
        <img
          @click="closeWin()"
          src="/images/icon_close.png"
          style="margin-left: 35px; width: 19px; height: 19px; object-fit: cover"
        /></div>
      </div>
   
    </div> -->

    <div class="block">
      <div class='r'>
        <div class="left_c childcenter" style="width:90%;font-weight:bold;">Leave Us a Message</div>
        <div class="right_c"><img
          @click="closeWin()"
          src="/images/icon_close.png"
          style="margin-left: 35px; width: 19px; height: 19px; object-fit: cover"
        /></div>
      </div>
    </div>

    <div class="form-box" v-if="success == ''">
    <!--   <div class="form-tit" style="border-top: 1px solid #f6f6f6; padding: 8px">
        Leave Us a Message
      </div> -->

      <el-form :inline="true" ref="rieForms" autocomplete="off" :model="rieForm" :rules="rules">
        <div>Name <span style='color:red'> *</span></div>
        <el-form-item prop="name" style="width:100%;">
          <el-input style="width:100%;" v-model="rieForm.name" placeholder="Name"></el-input>
        </el-form-item>

        <div>Email <span style='color:red'> *</span></div>
        <el-form-item label=""  style="width:100%;" prop="email">
          <el-input style="width:100%;" v-model="rieForm.email" placeholder="Email"></el-input>
        </el-form-item>

        <div>Phone <span style='color:red'> *</span></div>
        <el-form-item prop="telephone" style="width:100%;">
          <el-input style="width:100%;" v-model="rieForm.telephone" @input="acceptNumber" placeholder="Phone"></el-input>
        </el-form-item>

        <div>Your Request <span style='color:red'> *</span></div>
        <el-form-item prop="enquiry" style="width:100%;">
          <el-input  style="width:100%;"
            type="textarea"
            v-model="rieForm.enquiry"
            placeholder="Your Request"
            rows="2"
             class="custom-placeholder"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div
      style="
        flex-direction: column;
        border: 1px solid red;
        padding-top: 0px;
        margin-top: 5px;
        justify-content: center;
        align-items: center;
        border: 0px solid red;
        display: flex;
      "
    >
      <div
        v-if="success == ''"
        style="
          border: 1px solid red;
          margin-top: 0px;
          padding-top: 0px;
          justify-content: center;
          align-items: center;
          border: 0px solid red;
          color:black;
        "
        class="submit"
        @click="regsubmit"
      >
        Submit
      </div>

      <div
        v-if="error != ''"
        class="error"
        style="height: auto; word-break: keep-all; margin: 5px"
      >
        {{ error }}
      </div>
      <div
        v-if="success != ''"
        class="success"
        style="clear: both; height: auto; word-break: keep-all;margin: 5px"
      >
        {{ success }}
      </div>
    </div>
  </div>
</template>

<script>
import Request from '@/services/Request'
import '@/assets/main.css'

export default {
  props: {
    show: {
      type: Boolean
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick, true)
  },
  unmounted() {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  data() {
    return {
      error: '',
      success: '',
      submited: false,
      resWindow: false,
      rieForm: {
        name: '',
  
        email: '',
        telephone: '',
        enquiry: ''
      },

      rules: {
        name: [
          {
            required: true,
            message: 'Name cannot be empty',
            trigger: ['blur', 'touch']
          },
          {
            pattern: /^[a-zA-Z\s]*$/,
            message: 'Name cannot include numbers',
            trigger: 'blur'
          }
        ],

        email: [
          {
            required: true,
            message: 'Email cannot be empty',
            trigger: 'blur'
          },
          {
            // pattern: /^[a-z0-9!'#$%&*+\/=?^_`{|}~-]+(?:\.[a-z0-9!'#$%&*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-zA-Z]{2,}$/i,
            pattern:
              /^(([A-Za-z0-9!#$%&'*+/=?^_`{|}~]+(\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~]+)*)|\"([A-Za-z0-9!#$%&'*+/=?^_`{|}~\.\(\),:;<>@\[\\] ]|\\\\|\\\")+\")@(([A-Za-z0-9]{3,}(\-[A-Za-z0-9]+)*)\.([A-Za-z0-9]+(\-[A-Za-z0-9]+)*\.)*[A-Za-z]{2,})|\[((\d{1,3}(\.\d{1,3}){3})|IPv6(\:[a-zA-F0-9]{0,4}){1,7})\]$/i,
            message: 'Please enter correct email',
            trigger: 'blur'
          }
        ],
        telephone: [
          {
            required: true,
            message: 'Telephone cannot be empty',
            trigger: 'blur'
          },
          {
            pattern:
              /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
            message: 'Please enter correct Phone Number',
            trigger: 'blur'
          }
        ],
        enquiry: [
          {
            required: true,
            message: 'Enquiry cannot be empty',
            trigger: 'blur'
          },
          {
            pattern: /^(?!\s*$)(?=.*[a-zA-Z])[\w\s.,;:!?\'"()\-@#$%^&*+=\[\]{}<>_~`\n\r\t]+$/,
            message: 'Please enter valid enquiry',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    //	this.success = "Message sent! Thanks for your contact us!";
  },
  watch: {
    email(value) {
      // binding this to the data value in the email input
      this.rieForm.email = value
      this.validateEmail(value)
    }
  },
  methods: {
    acceptNumber() {
      var x = this.rieForm.telephone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      this.rieForm.telephone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
    },

    validateEmail(value) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        this.msg['email'] = ''
      } else {
        this.msg['email'] = 'Invalid Email Address'
      }
    },
    handleOutsideClick(e) {
      const panel = this.$refs.panel
      if (panel == null) {
        return
      }
      const panelRect = panel.getBoundingClientRect()
      // const pickerRect = inputBox.getBoundingClientRect();

      const isPanelClicked =
        e.clientX >= panelRect.left &&
        e.clientX <= panelRect.right &&
        e.clientY >= panelRect.top &&
        e.clientY <= panelRect.bottom
      // const isPickerClicked = (
      //   e.clientX >= pickerRect.left &&
      //   e.clientX <= pickerRect.right &&
      //   e.clientY >= pickerRect.top &&
      //   e.clientY <= pickerRect.bottom);

      // if (data.showPannel && !isPanelClicked && !isPickerClicked) {
      // Close the panel if it is clicked outside of the panel
      if (!isPanelClicked) {
        // this.close()
      }
    },
    closeWin() {
      this.$emit('close') // 当点击关闭按钮时，触发close事件
    },
    close() {
      this.$emit('close')
    },
    submit() {
      this.$emit('email', this.form)
    },
    formvalidater() {
      let isformCompleted = false
      this.$refs.rieForms.validate((valid) => {
        //console.log(valid)
        if (!valid) {
          isformCompleted = false
        } else {
          isformCompleted = true
        }
      })
      return isformCompleted
    },
    regsubmit() {
      this.submited = true
      this.showthanks = false

      if (!this.formvalidater()) {
        //	return false;
      }
      this.success = ''
      this.error = ''
      if (this.rieForm.name == '') {
        this.error = 'Please fill in name'
      } else if (this.rieForm.email == '') {
        this.error = 'Please fill in email'
      } else if (this.rieForm.telephone == '') {
        this.error = 'Please fill in phone number'
      } else if (this.rieForm.enquiry == '') {
        this.error = 'Please fill in enquiry'
      }

      if (this.error == '') {
        new Request().webPost(
          this.rieForm,
          (res) => {
            //console.log('res', res)
            if (res.hasOwnProperty('redirect')) {
              let redirect = res.redirect
              if (redirect.indexOf('success=1') >= 0) {
                this.resWindow = true
                this.success = 'Message sent successfully! Thanks for contacting us!'
              }
            } else {
              if (res.hasOwnProperty('error_email')) this.error += res.error_email
              if (res.hasOwnProperty('error_name')) this.error += res.error_name
              if (res.hasOwnProperty('error_enquiry')) this.error += res.error_enquiry
            }
            //if (this.error == "") this.error = "Something wrong!";
          },
          'information/contact'
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$backPrimary: #fafafa;



.loginpage {
  position: fixed;
  width: 300px;
  top: 9rem;
  right: 150px;
  /*  left: 50%;
  transform: translateX(-50%); */
  background-color: white;
  padding: 20px;
  border: 1px solid #e5e5e5;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  border-radius: 25px;
  z-index: 99;
  background: #fff;
  padding: 15px;
  font-size:1.4083rem;
}

:deep(.el-input__inner::placeholder, .el-textarea__inner::placeholder) {
  font-family: 'Poppins-Regular';
  font-size: 1.3rem;
}

:deep(.el-dialog) {
  position: fixed;
  right: 50rpx;
  top: 55rpx;
  border-radius: 20rpx;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    border-radius: 20rpx 20rpx 0 0;
  }

  .el-dialog__body {
    background-color: #ffffff;
  }
}

:deep(.el-form-item) {
  margin-top: 10rpx;

  .el-input__inner {
    border: none;
    border-radius: 8px;
    background-color: $backPrimary;
    padding-left: 0px;
  }

  .el-input__inner:focus {
    border: none;
  }

  .el-textarea__inner:focus {
    border: none;
  }

  .el-textarea__inner {
    border: 0px;
    border-radius: 8px;
    background-color: $backPrimary;
    box-shadow: 0 0 0 0;
    padding-left: 6px;

  }
  .el-textarea__inner::placeholder {
   font-size:1.3rem;

  }

  .el-form-item__error {
    font-size:1.0833rem;
  }
}

.el-divider {
  margin: 20rpx 0;
  background-color: $backPrimary;
}

.contact-box {
  text-align: center;

  .contact {
    font-size: 16rpx;
    font-family: Poppins;
    font-weight: 400;
    color: #333333;
    line-height: 21rpx;
  }

  .email-box {
    margin-top: 5px;
    padding: 10px;

    background: #fafafa;
    border-radius: 45px;

    .expert {
      font-size:1.1917rem;
      font-family: Poppins;
      font-weight: 400;
      color: #a6a6a6;
      line-height: 1.95rem;
    }

    .email {
      font-size:1.1917rem;
      font-family: Poppins;
      font-weight: bold;
      color: #333333;
      line-height: 1.95rem;
    }
  }
}

.form-tit {
  text-align: center;
  font-size: 16rpx;
  font-family: Poppins;
  font-weight: 400;
  color: #333333;
  line-height: 16rpx;
}

.submit {
  cursor: pointer;
  text-align: center;
  height: 42rpx;
  line-height: 42rpx;
  background: #00f1bd;
  border-radius: 28rpx;
  font-size: 18rpx;
  font-family: Poppins;
  font-weight: bold;
  color: #ffffff;
}
</style>
